<template>
    <v-container
        fluid
        class="px-4"
        v-if="saleAgent">
        <v-row>
            <!-- <detail-form-item
                cols="12"
                :label="$t('saleAgent.details.requestDate')"
                :value="`${$util.getDDMMYYYYDateFormat(saleAgent.createdAt)}  ${$util.getHHSSDateFormat(saleAgent.createdAt)}`"
                :disabled="true"> -->
            <v-col cols="12" class="mt-2">
                <div
                    class="subtitle-2 pb-2 font-weight-bold"
                    v-html="$t('saleAgent.details.requestDate')"/>
                <template >
                    <span>{{
                        $util.getDDMMYYYYDateFormat(saleAgent.createdAt)
                    }}</span>
                    <span class="grey--text">
                        {{
                            $util.getHHSSDateFormat(saleAgent.createdAt)
                        }}
                    </span>
                </template>
            </v-col>
            <!-- </detail-form-item> -->

            <!-- <detail-form-item
                cols="6"
                :label="$t('saleAgent.details.type')"
                :value="saleAgent.roles"
                :disabled="disablerole"> -->
            <v-col cols="6" class="mt-2">
                <div
                    class="subtitle-2 pb-2 font-weight-bold"
                    v-html="$t('saleAgent.details.type')"/>
                <template >
                    <v-select
                        outlined
                        hide-details
                        v-model="saleAgent.roles"
                        append-icon="expand_more"
                        height="40px"
                        item-value="value"
                        item-text="text"
                        :disabled="disablerole"
                        v-on:change="changeRoles"
                        :readonly="saleAgent.isVerified === 'approve'"
                        :menu-props="{
                            offsetY: true
                        }"
                        :items="agentTypeList"/>
                </template>
            </v-col>
            <!-- </detail-form-item> -->

            <!-- <detail-form-item
                cols="6"
                :label="$t('saleAgent.details.agentType')"
                :type="'select'"> -->
            <v-col cols="6" class="mt-2" v-show="saleAgent.roles === 'sales-agent'">
                <div
                    class="subtitle-2 pb-2 font-weight-bold"
                    v-html="$t('saleAgent.details.agentType')"/>
                <template >
                    <v-select
                        outlined
                        hide-details
                        v-model="saleAgent.subRoles"
                        v-on:change="changesubRoles"
                        append-icon="expand_more"
                        height="40px"
                        item-value="value"
                        item-text="text"
                        placeholder="เลือก"
                        :readonly="saleAgent.isVerified === 'approve'"
                        :disabled="disablerole"
                        :menu-props="{
                            offsetY: true
                        }"
                        :items="typeList"/>
                </template>
            </v-col>
            <!-- </detail-form-item> -->
            <detail-form-item
                required
                cols="12"
                :label="$t('saleAgent.details.name')"
                :value="saleAgent.name"
                @input="setName">
                <template v-slot:content>
                    <v-text-field
                        outlined
                        disabled
                        hide-details
                        height="40px"
                        v-model="saleAgent.name"/>
                </template>
            </detail-form-item>

            <!-- <detail-form-item
                required
                cols="6"
                :label="$t('saleAgent.details.passportId')"
                :value="saleAgent.idCardNumber"
                :type="'number'"
                @input="setidCardNumber"> -->
            <v-col cols="6" class="">
                <div
                    class="subtitle-2 pb-2 font-weight-bold"
                    v-html="$t('saleAgent.details.passportId') + ' ' +$t('required')"/>
                <template>
                    <v-text-field
                        outlined
                        hide-details
                        type='number'
                        height="32px"
                        @input="setidCardNumber"
                        @keydown="check_idnumber"
                        v-model="saleAgent.idCardNumber"/>
                </template>
            <!-- </detail-form-item> -->
            </v-col>
            <detail-form-item
                cols="6"
                :label="$t('saleAgent.details.carId')"
                :value="saleAgent.carLicense"
                @input="setcarLicense">
                <template v-slot:content>
                    <v-text-field
                        outlined
                        disabled
                        hide-details
                        height="40px"
                        v-model="saleAgent.carLicense"/>
                </template>
            </detail-form-item>

            <detail-form-item
                cols="12"
                :label="$t('saleAgent.details.company')"
                :value="saleAgent.organization"
                @input="setOrganization">
                <template v-slot:content>
                    <v-text-field
                        outlined
                        disabled
                        hide-details
                        height="40px"
                        v-model="saleAgent.organization"/>
                </template>
            </detail-form-item>

            <!-- <detail-form-item
                required
                :type="'number'"
                cols="6"
                :label="$t('saleAgent.details.phone')"
                :value="saleAgent.phonenumber"
                :input="setPhonenumber"> -->
            <v-col cols="6" class="">
                <div
                    class="subtitle-2 pb-2 font-weight-bold"
                    v-html="$t('saleAgent.details.phone') + ' ' +$t('required')"/>
                <template >
                    <v-text-field
                        outlined
                        hide-details
                        height="32px"
                        type='number'
                        @input="setPhonenumber"
                        @keydown="check_numbervalidate"
                        v-model="saleAgent.phonenumber"/>
                </template>
            <!-- </detail-form-item> -->
            </v-col>
            <detail-form-item
                cols="6"
                :label="$t('saleAgent.details.email')"
                :value="saleAgent.email"
                @input="setEmail">
                <template v-slot:content>
                    <v-text-field
                        outlined
                        disabled
                        hide-details
                        height="40px"
                        v-model="saleAgent.email"/>
                </template>
            </detail-form-item>

            <div class="col-6">
                <label class="form-label text-default-body text-gray mb-1 font-weight-bold"
                >{{$t('saleAgent.details.commission')}}</label
                >
                <v-text-field
                    class="mt-1"
                    outlined
                    :disabled="saleAgent.idCardNumber == '' ? true : false"
                    hide-details
                    height="40px"
                    :value="saleAgent.commission"
                    @input="setComission"
                    v-model="saleAgent.commission"/>
            </div>

            <div class="col-6">
                <div class="d-flex flex-row">
                    <label class="form-label text-default-body text-gray mb-1 font-weight-bold"
                    >เลือกประเภทCommission</label
                    >
                    <span class="mx-2 text-red"> * </span>
                </div>

                <v-select
                    outlined
                    hide-details
                    append-icon="expand_more"
                    height="40px"
                    v-model="saleAgent.commissionType"
                    item-value="value"
                    item-text="text"
                    :menu-props="{
                        offsetY: true
                    }"
                    :items="commissionTypeList">
                    <template v-slot:item="{ item }">
                        <div
                            class="subtitle-2 font-weight-bold">
                            {{ item }}
                        </div>
                    </template>

                    <template v-slot:selection="{ item }">
                        <div
                            class="subtitle-2 font-weight-bold">
                            {{ item }}
                        </div>
                    </template>
                </v-select>

                <!-- <div class="dropdown w-100">
                    <select
                        v-model="saleAgent.commissionType"
                        class="form-select dropdown-body "
                    >
                        <option value="" disabled selected>เลือก</option>
                        <option selected disabled class="font-Bai text-gray">เลือก</option>
                        <option value="percent" class="font-Bai text-gray">
                            Percent
                        </option>
                        <option value="bath" class="font-Bai text-gray">
                            Bath
                        </option>
                    </select>
                </div> -->
            </div>
            <detail-form-item
                cols="6"
                :label="$t('saleAgent.details.bookbankName')"
                :value="saleAgent.bookbankName"
                @input="setBookBankName">
                <template v-slot:content>
                    <v-text-field
                        outlined
                        disabled
                        hide-details
                        height="40px"
                        v-model="saleAgent.bookbankName"/>
                </template>
            </detail-form-item>
            <detail-form-item
                cols="6"
                :label="$t('saleAgent.details.bookbankNo')"
                :value="saleAgent.bookbankNo"
                @input="setBookBankNo">
                <template v-slot:content>
                    <v-text-field
                        outlined
                        disabled
                        hide-details
                        height="40px"
                        v-model="saleAgent.bookbankNo"/>
                </template>
            </detail-form-item>
            <!-- <detail-form-item
                cols="12"
                :label="$t('saleAgent.details.passportIdImage')"
                :value="saleAgent.imagePath"
                :disabled="true"> -->
            <v-col cols="6" class="mt-2">
                <template >
                    <img
                        :src="`${this.fileStore}/${saleAgent.imagePath}`"
                        :style="{ width: '300px', height: 'auto', borderRadius: '16px'}"/>
                </template>
            </v-col>
            <!-- </detail-form-item> -->
        </v-row>

    </v-container>

    <!-- <div v-else></div> -->
</template>

<script>
import DetailFormItem from '@/components/forms/DetailFormItem'
import { mapState } from 'vuex'

export default {
    name: 'SaleAgentDetailsView',

    components: {
        DetailFormItem
    },

    props: {
        saleAgent: {
            type: Object,
            default: () => ({})
        },
        disablerole: {
            type: Boolean,
            default: false
        },
        visibleBottom: {
            type: String,
            default: ''
        }
    },

    mounted () {
        this.fileStore = process.env.VUE_APP_FILE_STORE
    },

    computed: {
        ...mapState('saleagentList', ['agentlist', 'agentdetail']),
        ...mapState('saleagentRequestList', ['requestlist']),
        ...mapState('andamandaStaffListPage', ['stafflist'])
    },

    data () {
        return {
            agentTypeList: [
                {
                    text: 'Staff',
                    value: 'staff'
                },
                {
                    text: 'Sale Agent',
                    value: 'sales-agent'
                }
            ],
            commissionTypeList: [
                'percent',
                'bath'
            ],
            typeList: [
                'Street Counter',
                'Taxi / Van',
                'Tour Agency',
                'Hotel Concierge'
            ],
            fileStore: ''
        }
    },

    methods: {
        patchUpdate () {
            if (this.saleAgent.roles === 'staff') {
                this.patchStaff()
            } else {
                this.patchSaleAgent()
            }
        },
        patchSaleAgent () {
            this.$store.commit('saleagentList/setAgentdetail', this.saleAgent)
            this.$store.dispatch('saleagentList/patchAgentlist')
                .then((res) => {
                    console.log(res)
                    this.$store.dispatch('saleagentList/fetchAgentlist')
                    this.$emit('closeRightPanel', true)
                })
        },
        patchStaff () {
            this.$store.commit('andamandaStaffListPage/setStaffdetail', this.saleAgent)
            this.$store.dispatch('andamandaStaffListPage/patchStafflist')
                .then((res) => {
                    console.log(res)
                    this.$store.dispatch('andamandaStaffListPage/fetchStafflist')
                    this.$emit('closeRightPanel', true)
                })
        },
        deleteUser () {
            this.$store.dispatch('saleagentRequestList/deleteRequest')
                .then((res) => {
                    console.log(res)
                    this.$store.dispatch('saleagentRequestList/fetchRequestlist')
                })
        },

        patchRequest () {
            if ((this.saleAgent.subRoles === null || this.saleAgent.subRoles === '') && this.saleAgent.roles !== 'staff') {
                alert('กรุณาเลือกประเภทตัวแทนขาย')
                return
            }
            this.$store.commit('saleagentRequestList/setRequestdetail', this.saleAgent)
            this.$store.dispatch('saleagentRequestList/patchRequestlist')
                .then((res) => {
                    console.log(res)
                    this.$store.dispatch('saleagentRequestList/fetchRequestlist')
                    this.$emit('closeRightPanel', true)
                })
        },
        setName (value) {
            this.saleAgent.name = value
        },
        setidCardNumber (evt) {
            this.saleAgent.idCardNumber = evt.target.value
        },
        setcarLicense (value) {
            this.saleAgent.carLicense = value
        },
        setOrganization (value) {
            this.saleAgent.organization = value
        },
        setPhonenumber (evt) {
            this.saleAgent.phonenumber = evt.target.value
        },
        setEmail (value) {
            this.saleAgent.email = value
        },
        setComission (value) {
            this.saleAgent.commission = value
        },
        setBookBankName (value) {
            this.saleAgent.bookbankName = value
        },
        setBookBankNo (value) {
            this.saleAgent.bookbankNo = value
        },
        changesubRoles (value) {
            this.saleAgent.subRoles = value
        },
        changeRoles (value) {
            this.saleAgent.roles = value
        },
        changeVerified (value) {
            this.saleAgent.isVerified = value
        },
        setisActive (value) {
            this.saleAgent.isActive = value
            this.$store.commit('saleagentList/setActiveAgent', value)
        },
        check_numbervalidate (evt) {
            const numberRegex = new RegExp('')
            if (
                (numberRegex.test(evt.key) === false && evt.key !== 'Backspace') ||
                (evt.target.value.length >= 10 && evt.key !== 'Backspace')
            ) {
                evt.preventDefault()
            } else {
            }
        },
        check_idnumber (evt) {
            const numberRegex = new RegExp('^[0-9]+$')
            if (
                (numberRegex.test(evt.key) === false && evt.key !== 'Backspace') ||
                (evt.target.value.length >= 13 && evt.key !== 'Backspace')
            ) {
                evt.preventDefault()
            } else {
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.dropdown-body {
  border: solid 1px #CCCCCC !important;
  border-radius: 4px;
  display: flex !important;
  justify-content: space-between !important;
  align-items: center !important;
  width: 100%;
  height: 32px;
  margin-top: 2px;
  padding-left: 10px;
}
</style>
